window.theme = window.theme || {};

theme.CollectionGridSize = (function() {

  function CollectionGridSize(container) {
    this.container = container;

    if(!container){
      return;
    }

    this.bindElements();
    this.bindEvents();

  }

  CollectionGridSize.prototype = {

    bindElements: function(){
      const self = this;
      
      this.sizeButtons = this.container.querySelectorAll('.collection-view-count__button');
      this.gridContainer = this.container.querySelector('#product-grid');
    },

    bindEvents: async function(){
      const self = this;
      
      this.sizeButtons.forEach(function(button){
        button.addEventListener('click',function(){
          self.unselectAllButtons();
          this.classList.add('selected');
          self.gridContainer.classList.add(this.dataset.sizeClass);
        })
      });

    },

    unselectAllButtons: function() {
      const self = this;
      self.sizeButtons.forEach(function(sizeButton){
        sizeButton.classList.remove('selected');
        self.gridContainer.classList.remove(sizeButton.dataset.sizeClass);
      });
    }

  }

  return CollectionGridSize;

})();

document.addEventListener('DOMContentLoaded', function() {
  const collectionContainer = document.querySelector('.collection-main');
  if (collectionContainer){
    new theme.CollectionGridSize(collectionContainer);
  }
});